module.exports = __webpack_public_path__ + "media/new-pdf-report-layout/check-off-green-e66864c9.svg";